import { createSlice } from "@reduxjs/toolkit";
import { getListChangePointSetting } from "../../api/ChangePoint/changePointSetting";

// giá trị khởi tạo của state
const initialState = {
  listChangePointSetting: [],
  isLoadChangePointSetting: false,
  currentPage: 1,
  pageSize: 10,
  error: null,
  totalRecords: 0, // Tổng số bản ghi từ API
};

const changePointSettingSlice = createSlice({
  name: "changePointSetting", // tên phân biệt giữa các reduce
  initialState,
  reducers: {
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setPageSize: (state, action) => {
      state.pageSize = action.payload;
    },
    setTotalRecords: (state, action) => {
      state.totalRecords = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getListChangePointSetting.pending, (state) => {
        state.isLoadChangePointSetting = true;
        state.error = null;
      })
      .addCase(getListChangePointSetting.fulfilled, (state, action) => {
        state.isLoadChangePointSetting = false;
        state.listChangePointSetting = action.payload.data || [];
        state.currentPage = action.payload.current_page;
        state.pageSize = action.payload.per_page;
        state.totalRecords = action.payload.total;
      })
      .addCase(getListChangePointSetting.rejected, (state, action) => {
        state.isLoadChangePointSetting = false;
        state.error = action.payload;
      });
  },
});

export const { setCurrentPage, setPageSize, setTotalRecords } =
  changePointSettingSlice.actions;
export default changePointSettingSlice.reducer;
